import { Flex, Text, Spinner } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

type ProcessingStatus = 'pending' | 'processing' | 'completed' | 'failed';

interface TrackStatusBadgeProps {
  status: ProcessingStatus;
}

const statusConfig: Record<ProcessingStatus, { color: string; bg: string; i18nKey: string }> = {
  pending: { color: 'orange.500', bg: 'orange.100', i18nKey: 'admin.library.status.pending' },
  processing: { color: 'blue.500', bg: 'blue.100', i18nKey: 'admin.library.status.processing' },
  completed: { color: 'green.500', bg: 'green.100', i18nKey: 'admin.library.status.completed' },
  failed: { color: 'red.500', bg: 'red.100', i18nKey: 'admin.library.status.failed' },
};

export function TrackStatusBadge({ status }: TrackStatusBadgeProps) {
  const { t } = useTranslation();
  const config = statusConfig[status] ?? statusConfig.pending;

  return (
    <Flex
      align="center"
      justify="center"
      gap={1}
      px={3}
      py={1}
      borderRadius="full"
      bg={config.bg}
      display="inline-flex"
      data-testid="track-status-badge"
    >
      {status === 'processing' && <Spinner size="xs" color={config.color} />}
      <Text fontSize="10px" color={config.color} fontWeight="700" textTransform="uppercase" letterSpacing="wide">
        {t(config.i18nKey)}
      </Text>
    </Flex>
  );
}
